import { GATES } from "@/data/temple";

export default function Marquee() {
  const items = GATES.map((g) => g.name);
  const row = (k) => (
    <div key={k} className="flex items-center shrink-0" aria-hidden={k === 1}>
      {items.map((name, i) => (
        <span key={name} className="flex items-center">
          <span className="font-display italic text-[clamp(2.2rem,6vw,5.5rem)] leading-none px-8 sm:px-12 text-[#F2E8DF]">
            {name}
          </span>
          <span className="font-tt-mono text-[12px] text-[#D9B47A] tracking-[0.3em]">
            {String(i + 1).padStart(2, "0")} ◆
          </span>
        </span>
      ))}
    </div>
  );
  return (
    <section data-testid="gates-marquee" className="marquee-wrap relative py-10 sm:py-14 border-y border-[#D9B47A]/15 overflow-hidden bg-[#0D0908]">
      <div className="marquee-track">{[0, 1].map(row)}</div>
    </section>
  );
}
